/**
 * @description LinkTooltip component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/LinkTooltip
 */

import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from './Tooltip';

/**
 * @description The LinkTooltip component.
 * @class
 * @extends {React.Component}
 */
class LinkTooltip extends Tooltip {

    /**
     * @description Returns the content to be inserted into the Tooltip.
     * @returns {Object} A JSX object representing the DOM structure.
     */
    getTooltipContent() {
        return (
            <div className='LinkTooltip'>
                <div className='LinkTooltip-label'>
                    Location:
                    <span>{this.props.link.name}</span>
                </div>
                <div className='LinkTooltip-label'>
                    Timeframe:
                    <span>{this.props.link.timeframe}</span>
                </div>
                <div className='LinkTooltip-label'>
                    Actual Journey Time:
                    <span>{this.props.link.journeyTimeSeconds}s</span>
                </div>
                <div className='LinkTooltip-label'>
                    Expected Journey Time:
                    <span>{this.props.link.expectedTimeSeconds}s</span>
                </div>
            </div>
        );
    }
}

LinkTooltip.defaultProps = {
    link: {}
};

LinkTooltip.propTypes = {
    link: PropTypes.object.isRequired
};

export default LinkTooltip;
